class CustomersAccountPage {
  constructor() {

  }
}


export default () => {
  new CustomersAccountPage();
};
